import { FormControl, Stack, Typography, TextField, Button, FormControlLabel, Checkbox } from '@mui/material';
import { useState, Fragment, useContext } from 'react';

import { AuthContext } from '../../../auth/authContext';
import { urlLogin } from '../../../helpers';
import { useForm } from '../../../hooks/useForm';
import { types } from '../../../types/types';

import '../style.css';

export const PrincipalForm = ({ setForgot }) => {

  const {dispatch} = useContext(AuthContext);
  const [loginIsCorrect, setLoginIsCorrect] = useState(true);
  const [formValues, handleInputChange] = useForm({
    email: '',
    password: '',
    remember: ''
  });

  const { email, password, remember } = formValues;

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(urlLogin, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          email : email,
          password:password
      }
    }).then(r => r.json()).then(d => {
      if (!d.error.status) {
        remember ? localStorage.setItem('authToken', d.data.token) : sessionStorage.setItem('authToken', d.data.token);

        dispatch({
          type: types.login,
          payload : {email: email, logged : true, updatePass: d.data.updatePass, rol: d.data.rol  }
        })
      } else {
        setLoginIsCorrect(false);
      }
    })
  }
  const handleForgot = () => {
    setForgot(true);
  }

  return (
    <Fragment>
      <FormControl component='form' className="login_container" onSubmit={handleSubmit} sx={{ mb: '2rem' }}>
        <Stack spacing={1} pt={2} pb={2} >
          <Typography textAlign='center' variant="h5" color="primary">Login</Typography>

          <Stack flexWrap='wrap' alignItems='center' width='100%' gap={0} spacing={0}>

            <TextField
              label="Email"
              type="search"
              variant="standard"
              name="email"
              value={email}
              onChange={handleInputChange}
              sx={{ width: '70%' }}
            />
            <Button variant="text" size='small' onClick={handleForgot} type='submit'>¿Olvidaste la contraseña?</Button>
            <TextField
              label="Contraseña"
              type="password"
              variant="standard"
              name="password"
              value={password}
              onChange={handleInputChange}
              sx={{ width: '70%' }}
            />

          </Stack>
          <Stack pt={2} width='100%' alignItems='center' pb={2}>
            <FormControlLabel control={<Checkbox value={remember} name='remember' onChange={handleInputChange} />} label="Recordar usuario" />
            <Button variant="contained" size='small' sx={{ width: '70%' }} type='submit'>Ingresar</Button>
          </Stack>
        </Stack>
      {!loginIsCorrect && <Typography variant='subtitle1' sx={{color:'red'}}>Email o contraseña incorrectas</Typography>}
      </FormControl>
    </Fragment>
  )
}
